import {
  Box,
  CollapsibleCard,
  Stack,
  TextField,
  Typography,
} from '@atgfr8/atg-ui-tailwind';
import { getDoNotSolicitCustomers } from '@store/prospect';
import { CloseIcon, AlertOctagonIcon, MagnifyIcon } from '@atgfr8/icons';
import { debounce } from 'lodash';
import { createMemo, createSignal, onMount } from 'solid-js';

export const DoNotSolicitCustomers = (props: {
  title: string;
  type: 'Revenue Dashboard' | 'Prospect' | 'Customer';
}) => {
  const [doNotSolicitCustomers, setDoNotSolicitCustomers] = createSignal<{
    data: string[];
    loading: boolean;
  }>({
    data: [],
    loading: false,
  });

  const [inputValue, setInputValue] = createSignal('');
  const [searchQuery, setSearchQuery] = createSignal('');

  const handleSearchInput = debounce((value: string) => {
    setSearchQuery(value);
  }, 300);

  const filteredCustomers = createMemo(() => {
    const query = searchQuery().toLowerCase();
    return doNotSolicitCustomers().data.filter((name) =>
      name.toLowerCase().includes(query),
    );
  });

  onMount(async () => {
    setDoNotSolicitCustomers((prev) => ({ ...prev, loading: true }));
    const res = await getDoNotSolicitCustomers();
    if (res && res.isSuccess) {
      setDoNotSolicitCustomers((prev) => ({
        ...prev,
        data: res.value,
      }));
    }
    setDoNotSolicitCustomers((prev) => ({ ...prev, loading: false }));
  });

  return (
    <Box>
      <CollapsibleCard
        startIcon={<AlertOctagonIcon />}
        expanded={props.type !== 'Customer'}
        startTitle={props.title}
        contentClass="h-[200px]! p-0!"
        loading={doNotSolicitCustomers().loading}
        bannerColor="bg-[#f7a7a9]"
        textColor="black"
        headerClass="[&_svg]:fill-black!"
        class={props.type === 'Revenue Dashboard' ? 'mb-2' : 'm-0'}
      >
        <div class="p-1">
          <TextField
            label="Search"
            value={inputValue()}
            onChange={(value: string | number | undefined) => {
              if (typeof value === 'string') {
                setInputValue(value);
                handleSearchInput(value);
              }
            }}
            endIcon={
              Boolean(searchQuery()) ? (
                <CloseIcon
                  onClick={() => {
                    setInputValue('');
                    setSearchQuery('');
                  }}
                  style={{ cursor: 'pointer', 'z-index': 49 }}
                />
              ) : (
                <MagnifyIcon />
              )
            }
            maxLength={50}
            style={{
              'margin-top': '8px',
              'margin-bottom': '8px',
              'padding-left': '5px',
              'padding-right': '5px',
              'font-size': '14px',
              'max-width': props.type === 'Customer' ? '400px' : '100%',
            }}
            placeholder="Search Customer Name"
            dataTestId={'search-textInput'}
          />
        </div>

        <Box class="overflow-y-auto!" style={{ height: 'calc(100% - 50px)' }}>
          <Typography class="text-[14px]! font-bold p-2" variant="body1">
            Customer Name
          </Typography>
          <Stack spacing={0.25}>
            {filteredCustomers().length === 0 ? (
              <Typography
                class="text-[14px]! font-bold p-1! ml-[5px]! bg-[#f7a7a9]!"
                variant="body1"
              >
                No Records
              </Typography>
            ) : (
              filteredCustomers().map((item: string) => (
                <Typography
                  class="text-[14px]! font-bold bg-[#f7a7a9]! p-1!"
                  variant="body1"
                >
                  {item}
                </Typography>
              ))
            )}
          </Stack>
        </Box>
      </CollapsibleCard>
    </Box>
  );
};
